document.addEventListener("DOMContentLoaded", function () {
    const notifyMeBtn = document.querySelector(".notify-me-btn");
    const notifyMeModal = document.getElementById("notifyMeModal");
    const closeModal = document.querySelector(".close-modal");
    const backdrop = document.getElementById('prompt-background');
  
    if (notifyMeBtn && notifyMeModal && closeModal) {
      notifyMeBtn.addEventListener("click", function () {
        notifyMeModal.classList.add('block\!');
      });
  
      closeModal.addEventListener("click", function () {
        notifyMeModal.classList.remove('block\!');
      });
  
      window.addEventListener("click", function (event) {
        const isModalOpen = notifyMeModal.classList.contains('block\!');
        
        if (isModalOpen && event.target === backdrop) {
          notifyMeModal.classList.remove('block\!');
        }
      });
    }
  });
  